import React, { useState } from 'react'
import Layout from '../../../components/layouts'
import Banner from '../../../components/features/Banner'
import SEO from '../../../components/common/SEO';
import ReactWOW from 'react-wow'
import FeatureCards from "../../../components/features/FeatureCards"

export const query = graphql`
  query Forms {
    site {
      siteMetadata {
        defaultTitle: title
        titleTemplate
        defaultDescription: description
        siteUrl: url
        defaultImage: image
        twitterUsername
      }
    }
  }
`

export default ({ data }) => {
  const [toggler, setToggler] = useState(false)
  const lightboxProps = {
    toggler: toggler,
    setToggler: setToggler,
    sources: ["https://www.youtube.com/watch?v=xE2yXvWB038"],
  }

  const bannerProps = {
    title: 'Forms',
    subtitle: `Paper forms and records can pile up in a hurry and turn any organized desk or filing cabinet into a mountain of headaches. Conquer your workflow by submitting documents via email, fax, or uploading directly into Workhub. Review, approve, and manage submissions in the Administrator portal. Relish in your newfound desk space and rediscover your kid' school pictures.`,
    featureName: 'behaviourObservations',
    rightButtonText: 'Why Certificate Tracking Software?',
    rightButtonSrc: 'https://www.youtube.com/watch?v=xE2yXvWB038',
    mockupImg: "/features/forms/forms-banner.png"
  }

  const seo = {
    title: 'Workhub | Free Form Management Software Submit Online',
    description: 'Create forms from templates, link to online forms, assign them to locations & submit electronically via email, fax or uploading to the Workhub app.',
    image: '/features/forms/social-card.jpg',
    // pathname,
    // article
  }

  const featureIndex = [
    {
      title: "Templating",
      para: "Upload a template for each form type, or link to an online form and specific submission frequencies.",
    },
    {
      title: "Identify & Assign",
      para: "If a submission reveals that work is needed, an admin can assign an action item. The form it was created in is automatically linked providing context for workers. ",
    },
    {
      title: "Notifications",
      para: "Workers who have been assigned tasks receive notifications via SMS (Text) or Email. ",
    },
    {
      title: "Submit Virtually",
      para: "Workers can submit forms by email, fax, web or on their smartphone. Click on the form or web link to fill it out and submit.",
    },

  ]


  return (
    <Layout {...lightboxProps}>
      <SEO {...seo} {...data.site} />
      <Banner {...bannerProps} {...lightboxProps} />

      <main className="feature-main">

        

   

      <section className="feature-section">
        <div className="container" >
          <div className="row switch-children">

            <div className="col-lg-6 feature-img">

            <ReactWOW animation="fadeInLeft" delay="0.9s">
              <img 
              className="feature-img-right" 
              src="\features\forms\forms-cartoon.png"
              alt="forms cartoon"
               /></ReactWOW>

            </div>


            <div className="col-lg-6 feature-text">
            <h2>Move Those filing cabinets online</h2>
            <p>You can provide form templates for workers to access easily, either by uploading a blank form for download or by providing a link to an online form. Forms can be assigned to your locations and assets, and you can set a frequency (every day, once a week, twice a month, semi-annually, etc.) for easy tracking of submissions and deadlines. Forms that aren’t submitted according to your chosen frequency will appear as past due. You can choose if form submissions need approval by an admin, ensuring the contents are exactly what you (and your auditors) expect.</p>
            </div>
          </div>
        </div>
      </section>


      <section className="feature-section">
        <div className="container" >
          <div className="row">

        
            <div className="col-lg-6 feature-text">


              <h2>Submit virtually and save time (and paper)</h2>
              <p>
                Save yourself and your workers time, filing, and a whole heap of headaches by having forms submitted online. Workers can simply tap the form they need to fill, download it to their device, fill it out, and submit. Submitted forms are housed in inboxes within Workhub, allowing for easy review and retrieval. Online forms can also be set up to automatically include the name, location, and assets included in the submission so you don’t need to spend extra time nailing down details - just submit and approve!
              </p>
              <p>
                Incentivizing workers to keep up with their forms has never been easier than with Workhub’s rewards program. Each form type can be tailored to award points for submission, so your workers are sure to submit what’s needed on time; fantastic for that office checklist no one has gotten around to in ages!
              </p>
            </div>

            <div className="col-lg-6 feature-img">

            <ReactWOW animation="fadeInRight" delay="0.9s">

              <img 
              className="feature-img-left" 
              src="\features\forms\forms-tablet.png"
              alt="forms admin computer view"
                 />

                </ReactWOW>

            </div>

          </div>
        </div>
      </section>



      <section className="feature-section">
        <div className="container" >
          <div className="row switch-children">

            <div className="col-lg-6 feature-img">

            <ReactWOW animation="fadeInLeft" delay="0.9s">

              <img 
            className="feature-img-right"
              src="\features\forms\forms-admin.png"
                />

                </ReactWOW>

            </div>


            <div className="col-lg-6 feature-text">

              <h2>And ... Action!</h2>
              <p>
                If a submitted form reveals work needed, an administrator can create and assign an action item. The action item contains an explanation of a deficiency identified and corrective action needed. If the worker needs more context, the originating form is automatically linked for easy access. Notify the worker who needs to complete the job via SMS or Email, then sit back and relax!
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-overview-container">
          <h2>Overview</h2>

          <div className="feature-overview-grid">
            {featureIndex.map(item => (
              <FeatureCards title={item.title} para={item.para} />
            ))}
          </div>
        </section>

      </main>

    </Layout>
  )
}